import './App.css';
import { useEffect, useRef, useState, useContext, useLayoutEffect } from 'react';

import { BrowserRouter } from "react-router-dom";
import MainRouter from "./routes";
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
import ThemeConfig from './theme';
import NotistackProvider from './components/NotistackProvider';
import RtlLayout from './components/RtlLayout';
import Settings from './components/settings';
// hooks
import useAuth from './hooks/useAuth';
import { useTranslation } from "react-i18next";

import { CurrentLanguage } from "./utils/language_util";
import LoadingScreen from './components/LoadingScreen';
import Calling from './components/webrtc/Calling';
import { useSelector } from 'react-redux';
import ListMessageBubble from './layouts/dashboard/ListMessageBubble';
import VideoCalling from './components/webrtc/VideoCalling';
import StatusConnectingWidget from './components/widget/StatusConnectingWidget';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
//test
const App = () => {
    const { isInitialized, user } = useAuth();
    const { calling } = useSelector(state => state.janus)
    const { videoCalling } = useSelector(state => state.janusVideo)
    const { is_status_connect } = useSelector(state => state.widget)
    const { i18n } = useTranslation();
    const test = true;
    useLayoutEffect(() => {
        i18n.changeLanguage(CurrentLanguage());
    }, []);
   
    return (
        <BrowserRouter>
            <ThemeConfig>
                <ThemePrimaryColor>
                    <ThemeLocalization>
                        <RtlLayout>
                            <NotistackProvider>
                                <Settings />
                                {is_status_connect ? <StatusConnectingWidget open={is_status_connect} /> : null}
                                {videoCalling  ? <VideoCalling /> : null}
                                {calling ? <Calling /> : null}
                                {isInitialized ? <MainRouter /> : <LoadingScreen />}
                                {user && <ListMessageBubble />}
                            </NotistackProvider>
                        </RtlLayout>
                    </ThemeLocalization>
                </ThemePrimaryColor>
            </ThemeConfig>
        </BrowserRouter>
    );
}

export default App;
